"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const Login = ({ siteKey, dispatchCard }) => {
    const [username, setUsername] = (0, react_1.useState)("");
    const [password, setPassword] = (0, react_1.useState)("");
    const [loginMessage, setLoginMessage] = (0, react_1.useState)("");
    const [shake, setShake] = (0, react_1.useState)(false);
    const shakeButton = () => {
        setShake(true);
        setTimeout(() => {
            setShake(false);
        }, 300);
    };
    // trigger login on enter when username or password is focused
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            login();
        }
    };
    const login = () => {
        window.grecaptcha.ready(function () {
            window.grecaptcha.execute(siteKey, { action: "submit" }).then(function (token) {
                const googleSub = new URLSearchParams(window.location.search).get("google_sub");
                const postData = new FormData();
                postData.append("username", username);
                postData.append("password", password);
                postData.append("token", token);
                postData.append("google_sub", googleSub !== null && googleSub !== void 0 ? googleSub : "");
                fetch("user/login", {
                    method: "POST",
                    body: postData,
                })
                    .then((res) => res.text())
                    .then((data) => {
                    var _a;
                    if (data.trim() != "1") {
                        setLoginMessage(data);
                        shakeButton();
                        return;
                    }
                    // Redirect to requested path
                    const params = new URLSearchParams(window.location.search);
                    const redirect = (_a = params.get("redirect")) !== null && _a !== void 0 ? _a : window.location.pathname;
                    window.location.replace(window.location.origin + redirect);
                })
                    .catch((err) => console.log(err));
            });
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "login-box-msg", "data-testid": "login-card-element", children: loginMessage }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group mb-3", children: [(0, jsx_runtime_1.jsx)("input", { name: "username", type: "text", placeholder: "Your Username", required: true, className: "form-control", value: username, onChange: (e) => setUsername(e.target.value), onKeyDown: handleKeyPress }), (0, jsx_runtime_1.jsx)("div", { className: "input-group-append", children: (0, jsx_runtime_1.jsx)("div", { className: "input-group-text", children: (0, jsx_runtime_1.jsx)("span", { className: "fa-solid fa-user", style: { color: "#892203" } }) }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group mb-3", children: [(0, jsx_runtime_1.jsx)("input", { name: "password", type: "password", className: "form-control", placeholder: "Your Password", required: true, value: password, onChange: (e) => setPassword(e.target.value), onKeyDown: handleKeyPress }), (0, jsx_runtime_1.jsx)("div", { className: "input-group-append", children: (0, jsx_runtime_1.jsx)("div", { className: "input-group-text", children: (0, jsx_runtime_1.jsx)("span", { className: "fa-solid fa-lock", style: { color: "#892203" } }) }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "row mb-3", children: (0, jsx_runtime_1.jsx)("div", { className: "col", children: (0, jsx_runtime_1.jsx)("button", { id: "login-btn", type: "submit", className: `btn btn-danger btn-block ${shake ? "shake" : ""}`, onClick: login, children: "Log In" }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "row", children: (0, jsx_runtime_1.jsxs)("div", { className: "col", children: [(0, jsx_runtime_1.jsx)("div", { id: "g_id_onload", "data-client_id": "457151477419-p74n14m249rl6hi15bjp6tpbsoelvi1s.apps.googleusercontent.com", "data-context": "signin", "data-ux_mode": "popup", "data-login_uri": "user/google_login", "data-auto_prompt": "false" }), (0, jsx_runtime_1.jsx)("div", { className: "g_id_signin d-flex justify-content-center", "data-type": "standard", "data-shape": "rectangular", "data-theme": "outline", "data-text": "signin_with", "data-size": "large", "data-logo_alignment": "center" })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "row", children: (0, jsx_runtime_1.jsx)("div", { className: "w-100 mt-2 text-center", children: (0, jsx_runtime_1.jsx)("a", { style: { color: "#303030", fontSize: "14px" }, type: "button", onClick: () => dispatchCard({ type: "RESET_PASSWORD" }), "data-testid": "forgot-password-button", children: "Forgot password?" }) }) })] }));
};
exports.default = Login;
